(function (Drupal) {
  Drupal.behaviors.halifaxVvprForm = {
    attach: function () {
      const container = document.getElementById(
        'webform-submission-vpr-add-form'
      );
      const notResidentMessage = container.querySelector(
        '#edit-processed-text-07'
      );
      // Collect the text that's been set in the form and remove it from the element for now.
      // This means the site admin can still edit the message text.
      const notResidentMessageText = notResidentMessage.innerHTML;
      notResidentMessage.innerHTML = '';
      const notResidentButton = document.getElementById(
        'edit-are-you-a-resident-of-the-halifax-regional-municipality-no'
      );

      notResidentMessage.setAttribute('role', 'status');
      notResidentMessage.setAttribute('aria-live', 'polite');

      notResidentButton.addEventListener('focus', () => {
        setTimeout(() => {
          notResidentMessage.innerHTML = notResidentMessageText;
        }, 100);
      });

      notResidentButton.addEventListener('blur', () => {
        notResidentMessage.innerHTML = '';
      });
    },
  };
})(Drupal);
